﻿document.addEventListener('DOMContentLoaded', function () {
  if (document.getElementById('close-arrow') != null) {
    document
      .getElementById('close-arrow')
      .addEventListener('click', function (e) {
        e.preventDefault();
        document.getElementById('mypages-mainmenu').classList.add('hidden');
      });
  }

  var customerInfo = document.getElementById('customer-info') as HTMLDivElement;
  var mypagesView = document.querySelector('.mypages-view') as HTMLDivElement;
  var myPagesMenuDropdown = document.getElementById('mypages-mainmenu');
  var menuItems = document.querySelector('.site-header') as HTMLDivElement;
  var pageContent = document.querySelector('.page-content') as HTMLDivElement;
  var logo = document.querySelector('.logo') as HTMLDivElement;
  var topMenuChildBar = Array.from(document.querySelectorAll('.top-menu-item-child-bar')) as Array<HTMLDivElement>;

  var messageHeader = document.querySelector(
    '.message-header'
  ) as HTMLDivElement;
  
  var importantMessage = document.querySelector(
    '.important-message'
  ) as HTMLDivElement;
  if (window.innerWidth < 1024) {
    var siteHeaderItem = document.querySelector(
      '.site-header'
    ) as HTMLDivElement;
    var heightToBeFixed = 0;
    if (customerInfo != null) {
      if (window.innerWidth < 767) {
        if (importantMessage != null) {
          pageContent.style.marginTop =
            siteHeaderItem.offsetHeight + 108 + 'px';            

        } else {
          pageContent.style.marginTop = siteHeaderItem.offsetHeight + 48 + 'px';
        }
      } else {
        if (importantMessage != null) {
          pageContent.style.marginTop =
            siteHeaderItem.offsetHeight + 108 + 'px';            
        } else {
          pageContent.style.marginTop = siteHeaderItem.offsetHeight + 16 + 'px';
        }
      }
    }

    var messageHeader = document.querySelector(
      '.message-header'
    ) as HTMLDivElement;
    if (importantMessage) {
      if (mypagesView != null) {
        heightToBeFixed = 0;        
      } else {
        heightToBeFixed = importantMessage.offsetHeight;                
      }
    }
    window.addEventListener('scroll', function () {
      var siteHeader = document.querySelector('.site-header') as HTMLDivElement;
      var menuHeader = document.querySelector('.menu-header') as HTMLDivElement;
      var menuHeight = siteHeader.offsetHeight;
      var menuHeaderContainer = document.querySelector(
        '.menu-header-container'
      ) as HTMLDivElement;
      var myPagesMenu = this.document.getElementById('mypages-menu-button');
      var myPagesMenuItems = this.document.getElementById('mypages-mainmenu');

      if (this.scrollY > heightToBeFixed) {
        siteHeader.classList.remove('h-14');
        siteHeader.classList.add('h-12');
        menuHeader.classList.remove('h-14');
        menuHeader.classList.add('h-12');
        menuHeaderContainer.classList.remove('h-14');
        menuHeaderContainer.classList.add('h-12');        

        if (mypagesView != null) {
          mypagesView.classList.add('mt-[3rem]');
          mypagesView.classList.remove('mt-[3.5rem]');
        }
        if (myPagesMenu) {
          myPagesMenu.classList.remove('top-4');
          myPagesMenu.classList.add('top-0');
          myPagesMenuItems.classList.remove('top-4');
          myPagesMenuItems.classList.add('top-0');
        }
        if (messageHeader) {
          messageHeader.classList.add('h-12');
          messageHeader.classList.remove('h-14');
        }

        logo.classList.add('lgMax:w-40');
        logo.classList.remove('lgMax:w-44');
        var menuContentItems = document.querySelector(
          '.menu-content'
        ) as HTMLDivElement;

        menuContentItems.style.height = 'calc(100dvh - ' + menuHeight + 'px)';
      } else {
        if (messageHeader) {
          messageHeader.classList.remove('h-12', 'fixed');
          messageHeader.classList.add('h-14');
          if (customerInfo != null) {
            customerInfo.classList.add('fixed');
          }
        }
        siteHeader.classList.add('h-14');
        siteHeader.classList.remove('h-12');
        menuHeader.classList.add('h-14');
        menuHeader.classList.remove('h-12');
        menuHeaderContainer.classList.add('h-14');
        menuHeaderContainer.classList.remove('h-12');

        if (mypagesView != null) {
          mypagesView.classList.remove('mt-[3rem]');
          mypagesView.classList.add('mt-[3.5rem]');
        }

        if (myPagesMenu) {
          myPagesMenu.classList.add('top-4');
          myPagesMenu.classList.remove('top-2');
          myPagesMenuItems.classList.add('top-4');
          myPagesMenuItems.classList.remove('top-2');
        }
        logo.classList.remove('lgMax:w-40');
        logo.classList.add('lgMax:w-44');
      }
    });
  }
  var importantMessageItem = document.querySelector(
    '.important-message'
  ) as HTMLDivElement;
  var myPagesButtonMenu = document.querySelector(
    '#mypages-menu-button'
  ) as HTMLButtonElement;

  var messageItemHeight = 0;
  if (importantMessageItem != null) {
    messageItemHeight = importantMessageItem.clientHeight;
    topMenuChildBar.forEach(element => {
      if(element){
        element.style.top = `${importantMessageItem.clientHeight + 64 - window.scrollY}px`;                
      }          
    }
    );
  }

  var heightToBeFixed = 0;
  if (importantMessageItem) {
    heightToBeFixed = importantMessageItem.offsetHeight;
  }
  window.addEventListener('scroll', function () {
    var menuHeight = menuItems.offsetHeight;
    if (document.querySelector('.message-header')) {
      if (window.scrollY > heightToBeFixed) {
        messageHeader.classList.add('fixed');
        if (customerInfo != null) {
          if (!customerInfo.classList.contains('fixed')) {
            customerInfo.classList.add('fixed');
            customerInfo.style.marginTop = menuHeight + 'px';
            pageContent.style.marginTop =
              customerInfo.offsetHeight +
              heightToBeFixed +
              window.scrollY +
              'px';
          }
        } else {
          pageContent.style.marginTop = menuHeight + heightToBeFixed + 'px';
        }
        messageHeader.style.top = 0 + 'px';

        if (myPagesButtonMenu != null && myPagesMenuDropdown != null) {
          myPagesButtonMenu.style.marginTop = 0 + 'px';
          importantMessageItem.style.maxHeight = 0 + 'px';
          myPagesMenuDropdown.style.marginTop = 0 + 'px';
        }
        importantMessageItem.classList.add('hidden');
        topMenuChildBar.forEach(element => {
          if(element){
            element.style.top = "64px";            
          }          
        }
        );
      } else {
        messageHeader.classList.remove('fixed');
        if (customerInfo != null) {
          customerInfo.classList.remove('fixed');
          customerInfo.style.marginTop = 0 + 'px';
        }
        importantMessageItem.classList.remove('hidden');
        topMenuChildBar.forEach(element => {
          if(element){
            element.style.top = `${(importantMessageItem.clientHeight + 64) - this.window.scrollY}px`;
          }          
        }
        );

        pageContent.style.marginTop = 0 + 'px';
        importantMessageItem.style.maxHeight = '50vh';

        if (myPagesButtonMenu != null && myPagesMenuDropdown != null) {
          myPagesButtonMenu.style.marginTop = messageItemHeight + 'px';
          myPagesMenuDropdown.style.marginTop = messageItemHeight + 'px';
        }
      }
    }
  });
  if (
    importantMessageItem != null &&
    myPagesButtonMenu != null &&
    myPagesMenuDropdown != null
  ) {
    myPagesButtonMenu.style.marginTop = messageItemHeight + 'px';
    myPagesMenuDropdown.style.marginTop = messageItemHeight + 'px';
  }
});
